import { gql } from '@apollo/client';

export default gql`
  query getAllUsers {
    getAllUsers {
      ok
      error
      data {
        _id
        branch
        type
        username
        name
        email
        phone
        avatar
        address
        color
        lang
        tel
        fax
        mob

        isSuperAdmin
        isAdmin
        isBranchsAdmin
        isBranchAdmin
        isDepartAdmin
        isEmployee
        isFinance
        isOperate
        isPurchase
        isAdmin
        isEditor
        isWriter
        isViewer

        roles
        newroles
        title

        departmentId
        departmentName
        departmentNameAr
        departmentColor

        employeeId
        employeeName
        employeeNameAr
        employeePhone
        employeeColor

        block
        themeId
        verified

        userId

        createdAt
        updatedAt
      }
    }
  }
`;
